/* tslint:disable */
/* eslint-disable */
/**
 * Muisti API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PageLayoutViewPropertyType {
    String = 'string',
    Boolean = 'boolean',
    Number = 'number',
    Color = 'color'
}

export function PageLayoutViewPropertyTypeFromJSON(json: any): PageLayoutViewPropertyType {
    return PageLayoutViewPropertyTypeFromJSONTyped(json, false);
}

export function PageLayoutViewPropertyTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageLayoutViewPropertyType {
    return json as PageLayoutViewPropertyType;
}

export function PageLayoutViewPropertyTypeToJSON(value?: PageLayoutViewPropertyType | null): any {
    return value as any;
}

